import { PostWorkstationPayload, Staff, Workstation } from "app/models/practice"
import {
  GetTemplateWorkstationAvailabilitiesPayload,
  GetWorkstationAvailabilitiesPayload,
} from "app/models/workstationAvailability"
import { AxiosPromise } from "axios"
import { planningApi } from "./api"

type ApiStaff = Omit<Staff, "min"> & { minimum: number }
type ApiWorkstation = Omit<Workstation, "staff"> & { staff?: ApiStaff[] }

// Planning stores staff as {function_id, minimum}; the redux model keeps the Mongo-era {function, min}
export const toStaffPayload = (staff?: Staff[]): { function_id: string; minimum: number }[] | undefined =>
  // Typed counts arrive as strings; 0 means no requirement, so no staff row
  staff
    ?.map(({ function: practiceFunction, min }) => ({ function_id: practiceFunction.id, minimum: Number(min) }))
    .filter(({ minimum }) => minimum > 0)

export const fromApiWorkstation = ({ staff, ...workstation }: ApiWorkstation): Workstation => ({
  ...workstation,
  staff: staff?.map(({ minimum, ...rest }) => ({ ...rest, min: minimum })),
})

export const putWorkstations = ({ id, title, icon, staff }: Workstation): AxiosPromise =>
  planningApi(`/workstations/${id}`, {
    method: "PATCH",
    data: { title, icon, staff: toStaffPayload(staff) },
  })

export const patchWorkstationsOrder = (data: Workstation[]): AxiosPromise =>
  planningApi("/workstations_order", {
    method: "PATCH",
    data: { orderedIds: data.map(({ id }) => id) },
  })

export const getWorkstations = (): AxiosPromise<Workstation[]> =>
  planningApi("/workstations", { method: "GET" }).then(response => ({
    ...response,
    data: response.data.map(fromApiWorkstation),
  }))

export const postWorkstations = ({ title, icon, staff }: PostWorkstationPayload): AxiosPromise =>
  planningApi("/workstations", { method: "POST", data: { title, icon, staff: toStaffPayload(staff) } })

export const getWorkstationAvailabilities = ({
  params,
}: GetWorkstationAvailabilitiesPayload): AxiosPromise<Workstation[]> =>
  planningApi("/workstation_availabilities", {
    method: "GET",
    params,
  })

export const getTemplateWorkstationAvailabilities = ({
  id,
  params,
}: GetTemplateWorkstationAvailabilitiesPayload): AxiosPromise<Workstation[]> =>
  planningApi(`/templates/${id}/workstation_availabilities`, {
    method: "GET",
    params,
  })
